import * as yup from 'yup';
export const commCountrySchema = yup.string().required('required');
export const commLocationSchema = yup.string().nullable().required('required');
